import { render, staticRenderFns } from "./Profile-DeleteAcc.vue?vue&type=template&id=4e491c72&scoped=true&"
import script from "./Profile-DeleteAcc.vue?vue&type=script&lang=js&"
export * from "./Profile-DeleteAcc.vue?vue&type=script&lang=js&"
import style0 from "./Profile-DeleteAcc.vue?vue&type=style&index=0&id=4e491c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e491c72",
  null
  
)

export default component.exports